import React from 'react';
import PropTypes from 'prop-types';
import QuotesIcon from '../../assets/icons/quotes.svg';
import styles from './_testimonial-section.module.scss';

function TestimonialSectionItem({ name, description, logoName, position, logoAlt, ariaLabel }) {
    return (
        <div role="group" aria-label={ariaLabel}>
            <div className={styles['testimonial-section__item']}>
                <div className={styles['testimonial-section__quotes-icon']}>
                    <img src={QuotesIcon} alt="" aria-hidden="true" />
                </div>
                <div className={styles['testimonial-section__description']}>
                    <blockquote>
                        {description}
                    </blockquote>
                </div>
                {(name || position) && <div className={styles['testimonial-section__signature']}>
                    {name && <div className={styles['testimonial-section__signature-name']}>
                        {name}
                    </div>}
                    {position && <div className={styles['testimonial-section__signature-position']}>
                        {position}
                    </div>}
                </div>}
                {logoName && <div className={styles['testimonial-section__logo-wrapper']}>
                    <img src={logoName} alt={logoAlt} />
                </div>}
            </div>
            <hr className={styles['testimonial-section__divider']} />
        </div>
    );
}

TestimonialSectionItem.propTypes = {
    name: PropTypes.string,
    description: PropTypes.string.isRequired,
    logoName: PropTypes.string,
    position: PropTypes.string,
    logoAlt: PropTypes.string,
    ariaLabel: PropTypes.string.isRequired,
};

export default TestimonialSectionItem;